import { Component } from 'react'

import * as h from 'h'

import styles from './styles.scss'

export default class NewsMentions extends Component {
  render () {
    const { stories, request } = this.props

    const listItems = stories.map((story) =>
      h.div({ key: story.title, ...h.ca(styles.newsLinks) },
        h.a({
          href: story.url,
          target: '_blank',
          rel: 'noopener noreferrer'
        }, story.title)
      )
    )

    return stories.length === 0
      ? !request && h.p(null, 'No news mentions to display.')
      : h.div(h.ca(styles.newsMentionsWrapper),
          h.div(h.ca(styles.newsStoryLeft),
            listItems.filter((item, index) =>
              index % 2 === 0
            )),
          stories.length > 1 && h.div(h.ca(styles.newsStoryRight),
            listItems.filter((item, index) =>
              index % 2 !== 0
            ))
        )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/FacultyView/NewsMentions.js